import { RiskAssessmentTemplateResourceType } from "@components/shared/risk-assessment-templates/constants";

export const riskAssessmentReportOrderedResourceTypes = [
  RiskAssessmentTemplateResourceType.COUNTRY,
  RiskAssessmentTemplateResourceType.ORGANISATION,
  RiskAssessmentTemplateResourceType.LOCATION,
  RiskAssessmentTemplateResourceType.MATERIAL,
  RiskAssessmentTemplateResourceType.PRODUCT,
  RiskAssessmentTemplateResourceType.DELIVERY,
];
